import { InjectionToken } from "@angular/core";

export const asset_redirect_uri = new InjectionToken<string>("LoginUrlTokens for services like scientrix, dpredict");

export enum ASSET_REDIRECT_TARGET {
    SCIENTRIX = "scientrix",
    DPREDICT = "dpredict"
}
